import DomainHelper from "./brand-helper";

const INITIAL_STATE = {
  settings: DomainHelper.getMyDomainObject()
};

export default function(state = INITIAL_STATE) {
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/brand/brand-reducer.js